var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"goods-title"},[_c('div',{staticClass:"big-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"big-title-text"},[_vm._v(_vm._s(_vm.English))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }